<main>
  <div class="p-6">
    <div class="row">
      <div class="col-12">
        <section class="mt-3">
          <app-registration-approval-prompt></app-registration-approval-prompt>
        </section>
        <section class="d-none">
          <div class="video-link-container p-3 my-5">
            <h4 class="me-auto mb-0">دسترسی به ویدیوهای کارگاه‌های آموزشی</h4>
            <a
              pButton
              severity="primary"
              class="mt-sm-0 mt-2 no-underline!"
              [routerLink]="'/e-workshops'"
            >
              مشاهده ویدیوها
            </a>
          </div>
        </section>
        <section [tourStep]="TourStepId.UpcomingWorkshops">
          <app-my-upcoming-workshop-list></app-my-upcoming-workshop-list>
        </section>
        <div class="py-3"></div>
        <section [tourStep]="TourStepId.VideoWorkshops">
          <app-e-workshops-section></app-e-workshops-section>
        </section>
        <div class="py-4"></div>
        <section [tourStep]="TourStepId.Magazine">
          <app-afra-magazine></app-afra-magazine>
        </section>
      </div>
    </div>
  </div>
</main>
